import { render, staticRenderFns } from "./SelectMenu.vue?vue&type=template&id=6f9a7d8e"
import script from "./SelectMenu.vue?vue&type=script&lang=js"
export * from "./SelectMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports